const _ = require('underscore');
const state = {
  list: [
    {
      key: "0",
      title: "大数据分析",
      url: "/home",
      roles: [],
      active: false,
    },
    {
      key: "1",
      title: "电商数据管理",//授信数据管理
      url: "/data",
      roles: [],
      active: false,
      children: [
        {
          key: "1-0",
          title: "订单管理",
          url: "/data/order",
          roles: [],//账号等级
          active: false,
        },
        {
          key: "1-1",
          title: "采购管理",
          url: "/data/purchase",
          roles: [],//账号等级
          active: false,
        },
        {
          key: "1-2",
          title: "库存管理",
          url: "/data/inventory",
          roles: [],//账号等级
          active: false,
        },
        // {
        //   key: "1-3",
        //   title: "物流运单管理",
        //   url: "/data/logistics",
        //   roles: [],//账号等级
        //   active: false,
        // },
        {
          key: "1-4",
          title: "收款明细管理",
          url: "/data/trade",
          roles: [],//账号等级
          active: false,
        },
        {
          key: "1-5",
          title: "授权店铺信息",
          url: "/data/stores",
          roles: [],//账号等级
          active: false,
        },
      ],
    },
    {
      key: "2",
      title: "财务数据管理",//财务相关数据管理
      url: "/finance",
      roles: [],
      active: false,
      children: [
        {
          key: "2-0",
          title: "授信管理",
          url: "/finance/index",
          roles: [],//账号等级
          active: false,
        },
        {
          key: "2-1",
          title: "放款管理",
          url: "/finance/payment",
          roles: [],//账号等级
          active: false,
        },
        {
          key: "2-2",
          title: "还款管理",
          url: "/finance/repayment",
          roles: [],//账号等级
          active: false,
        },
        {
          key: "2-3",
          title: "利息管理",
          url: "/finance/interest",
          roles: [],//账号等级
          active: false,
        },
        {
          key: "2-4",
          title: "结算管理",
          url: "/finance/settle",
          roles: [],//账号等级
          active: false,
        },
        {
          key: "2-5",
          title: "项目财务报表",
          url: "/finance/report",
          roles: [],//账号等级
          active: false,
        }
      ]
    },
    {
      key: "3",
      title: "供应商管理",//供应商相关信息管理
      url: "/supplier",
      roles: [],
      active: false,
      children: [
        {
          key: "3-0",
          title: "供应商列表",
          url: "/supplier/index",
          roles: [],//账号等级
          active: false,
        },
      ]
    },
    {
      key: "4",
      title: "代付管理",//代付管理
      url: "/paymanage",
      roles: [],
      active: false,
      children: [
        {
          key: "4-0",
          title: "代付申请",
          url: "/paymanage/payanother",
          roles: [],//账号等级
          active: false,
        },
        {
          key: "4-1",
          title: "代付统计",
          url: "/paymanage/statics",
          roles: [],//账号等级
          active: false,
        },
      ]
    },
    {
      key: "5",
      title: "合同管理",
      url: "/contract",
      roles: [],
      active: false,
      children: [
        {
          key: "5-0",
          title: "代收合同",
          url: "/contract/receive",
          roles: [],//账号等级
          active: false,
        },
        {
          key: "5-1",
          title: "代付合同",
          url: "/contract/pay",
          roles: [],//账号等级
          active: false,
        },
      ]
    },
    {
      key: "6",
      title: "商户管理",//商户管理
      url: "/org",
      roles: ["root", "admin"],
      active: false,
      children: [
        {
          key: "6-0",
          title: "ERP商户",
          url: "/org/list",
          roles: [],//账号等级
          active: false,
        },
        {
          key: "6-1",
          title: "平台账户",
          url: "/org/accounts",
          roles: [],//账号等级
          active: false,
        },
        {
          key: "6-2",
          title: "商户团队",
          url: "/org/teams",
          roles: [],//账号等级
          active: false,
        },
      ]
    },
    {
      key: "7",
      title: "系统设置",
      url: "/account",
      roles: ["root", "admin"],
      active: false,
      children: [
        {
          key: "7-0",
          title: "账号管理",
          url: "/account",
          roles: [],//账号等级
          active: false,
        },
        {
          key: "7-1",
          title: "日志管理",
          url: "/account/timeboardnew",
          roles: [],//账号等级
          active: false,
        }
      ]
    },
  ],
};
function checkRole(roles, role) {
  return !Array.isArray(roles) || roles.length === 0 || roles.indexOf(role) > -1;
}
const getters = {
  getMenus: (state, getters, rootState) => (url) => {
    let menus = [];
    for (let i = 0; i < state.list.length; i++) {
      let menu = { ...state.list[i] };
      if (checkRole(menu.roles, rootState.user.role) === false) continue;
      if (menu.username && menu.username !== rootState.user.username) continue;
      if (menu.children) {
        menu.active = !!_.findWhere(menu.children, { url });
        let children = [];
        for (let j = 0; j < menu.children.length; j++) {
          let cmenu = menu.children[j];
          if (checkRole(cmenu.roles, rootState.user.role) === false) continue;
          if (cmenu.username && cmenu.username !== rootState.user.username) continue;
          cmenu.active = cmenu.url === url;
          children.push({ ...cmenu });
        }
        menu.children = children;
        if (menu.children.length > 0) menus.push({ ...menu })
      } else {
        menu.active = menu.url === url;
        menus.push({ ...menu });
      }
    }
    return menus;
  },
  getActiveMenuKeys: (state) => (list) => {
    let activeMenuKeys = [];
    for (let i = 0; i < list.length; i++) {
      let menu = list[i];
      if (menu.children) {
        for (let j = 0; j < menu.children.length; j++) {
          let cmenu = menu.children[j];
          if (cmenu.active) activeMenuKeys.push(cmenu.key);
        }
      } else if (menu.active) {
        activeMenuKeys.push(menu.key);
      }
    }
    console.log({ activeMenuKeys });
    return activeMenuKeys;
  },
  getCurrentMenu: (state) => (list, url) => {
    for (let i = 0; i < list.length; i++) {
      let menu = list[i];
      if (menu.children) {
        for (let j = 0; j < menu.children.length; j++) {
          let cmenu = menu.children[j];
          if (cmenu.url === url) return cmenu;
        }
      } else {
        if (menu.url === url) return menu;
      }
    }
    return {};
  },
  getParentMenu: (state) => (list, url) => {
    for (let i = 0; i < list.length; i++) {
      let menu = list[i];
      if (menu.children) {
        for (let j = 0; j < menu.children.length; j++) {
          let cmenu = menu.children[j];
          if (cmenu.url === url) return menu;
        }
      }
    }
    return {};
  },
};
const mutations = {};
const actions = {};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
